module.exports = __webpack_public_path__ + "static/media/bgw.a0e59b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bgw.jpg
// module id = 5763
// module chunks = 0